import { IGendecSettingsWire } from "@vmosolutions/oc-interfaces";
import { ActionType, IAppAction } from "../actions/Helpers";

/**
 * Single source of truth for the GenDec admin's server-side snapshot.
 *
 * Local in-progress edits stay in each component's own state - that's deliberate, so
 * uncommitted changes in one UI aren't visible or affected from the other.
 */
export interface IGendecState {
  /** True when a WebSocket UpdateGendec broadcast arrived since we last loaded. */
  stale: boolean;
  /**
   * The last-known-good server snapshot. `null` when not yet fetched OR when the
   * plugin isn't deployed for this customer (the GET returns null in both cases).
   */
  config: IGendecSettingsWire | null;
  /** True after the first fetch completes (regardless of result). Distinguishes "not loaded yet" from "loaded, plugin absent". */
  loaded: boolean;
}

const initialState: IGendecState = { stale: false, config: null, loaded: false };

export const GendecReducer = (state: IGendecState = initialState, action: IAppAction): IGendecState => {
  switch (action.type) {
    case ActionType.GENDEC_SET_STALE:
      return { ...state, stale: !!action.payload };
    case ActionType.GENDEC_SET_CONFIG:
      // A fresh snapshot supersedes any prior stale flag and counts as "loaded".
      return { ...state, config: (action.payload as IGendecSettingsWire | null) ?? null, loaded: true, stale: false };
    default:
      return state;
  }
};
